<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group">
        <label for="endereco_cidade">Senha antiga</label>

        <div class="input-group mb-3">
          <input :type="show_pass ? 'text' : 'password'" class="form-control" v-model="formData.senha_antiga" />

          <div class="input-group-append">
            <div
              @click="show_pass = !show_pass"
              class="input-group-text"
              style="cursor: pointer; background-color: white; border-left: 0px solid #000000 !important"
            >
              <span id="lock" class="fas fa-eye"></span>
            </div>
          </div>
        </div>

        <span style="color: red" v-for="error in v$.senha_antiga.$errors" :key="error.$uid">
          {{ error.$message }}
        </span>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="form-group">
        <label for="endereco_cidade">Nova senha</label>

        <div class="input-group mb-3">
          <input :type="show_new_pass ? 'text' : 'password'" class="form-control" v-model="formData.nova_senha" />

          <div class="input-group-append">
            <div
              @click="show_new_pass = !show_new_pass"
              class="input-group-text"
              style="cursor: pointer; background-color: white; border-left: 0px solid #000000 !important"
            >
              <span id="lock" class="fas fa-eye"></span>
            </div>
          </div>
        </div>

        <span style="color: red" v-for="error in v$.nova_senha.$errors" :key="error.$uid">
          {{ error.$message }}
        </span>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="form-group">
        <label for="endereco_cidade">Confirmação senha</label>

        <div class="input-group mb-3">
          <input :type="show_new_pass ? 'text' : 'password'" class="form-control" v-model="formData.confirmacao_senha" />

          <div class="input-group-append">
            <div
              @click="show_new_pass = !show_new_pass"
              class="input-group-text"
              style="cursor: pointer; background-color: white; border-left: 0px solid #000000 !important"
            >
              <span id="lock" class="fas fa-eye"></span>
            </div>
          </div>
        </div>

        <span style="color: red" v-for="error in v$.confirmacao_senha.$errors" :key="error.$uid">
          {{ error.$message }}
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button @click="update" class="btn btn-primary btn-sm">Salvar</button>
      <button id="close_editar" data-dismiss="modal" @click="close" style="margin-left: 5px" class="btn btn-danger btn-sm">Fechar</button>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { email, sameAs, helpers } from "@vuelidate/validators";
import { required, minLength } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["user", "closeModal"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, InputMask },

  setup() {
    const formData = reactive({
      nova_senha: "",
      confirmacao_senha: "",
      senha_antiga: "",
    });

    const rules = computed(() => {
      let local_rules = {
        senha_antiga: { required },
        nova_senha: {
          required,
          minLength: minLength(8),
        },
        confirmacao_senha: { sameAs: helpers.withMessage(" As senhas devem ser idênticas", sameAs(formData.nova_senha)) },
      };

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      show_pass: false,
      show_new_pass: false,
      isLoading: false,
      my_cidades: [],
      errors: [],
    };
  },

  mounted() {},

  methods: {
    async update() {
      console.log("Update");

      const result = await this.v$.$validate();

      if (result) {
        this.$swal
          .fire({
            title: "Confirmação",
            text: "Deseja alterar a senha?",
            icon: "warning",
            padding: "1.5em",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#4caf50",
            cancelButtonColor: "#d33",
            confirmButtonText: "Alterar",
          })
          .then((result) => {
            if (result.value) {
              let data = {
                senha_antiga: this.formData.senha_antiga,
                nova_senha: this.formData.nova_senha,
              };

              axios
                .post(`/user/update_password`, data)
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.success) {
                    this.showSuccessMessageWithButtonAndReload("Sucesso", "Cadastro atualizado!");
                  } else {
                    this.showErrorMessageWithButton("Ops...", response.data.msg);
                  }
                })
                .catch((error) => {
                  this.showErrorMessageWithButton("Ops..", error);
                  console.log(error);
                  this.isLoading = false;
                });
            }
          });
      } else {
        console.log(this.v$);
      }
    },

    close() {
      let btn = document.getElementById("close_editar");
      btn.click();

      this.closeModal();
    },
  },
};
</script>
